@for (media of mediaObject; track $index) {
  <!-- Instances of expired images still populating the json can cause issues,
  imageData.contentType checker is used to verify the validity of the image (as expired image objects do not include it).
  This use is specifically to prevent the rendering of the figure element with margins -->
  @if (media.contentType) {
    <figure class="article-image-wrapper ms-clear-x ms-clear-t mr-medium-b">
      @if (media.contentType === CmsContentType.CMVideo) {
        <div>
          <fin-video
            [videoUrl$]="media.dataUrl | finToObservable"
            [videoTitle$]="media.teaserTitle | finToObservable"
          />
        </div>
      } @else {
        <fin-content-image class="block image-height article-content-image" [imageData$]="media | finToObservable" />
      }

      @if (media.teaserText) {
        <figcaption
          [innerHTML]="media.teaserText | finSafe: 'html'"
          class="article-image-caption font-body-2 light-type ms-xxsmall-t nordic-blue-900-text text-icon-primary font-body-small"
        ></figcaption>
      }
    </figure>
  }
}
@if (markup) {
  <div class="ms-large-b article-markup" [innerHTML]="markup | finSafe: 'html'"></div>
}
